import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  getChatWithStudents,
  getChatWithTeacher,
} from "../../../api/endpoints/ChatEndpoints";
import { Chat, ChatType } from "../../../models/Chat";

export default function useGetChat(chatId: string, chatType: ChatType) {
  return useQuery<Chat, AxiosError>({
    queryKey: ["get-chat", chatId, chatType],
    queryFn: () =>
      chatType === "chat-with-teacher"
        ? getChatWithTeacher(chatId)
        : getChatWithStudents(chatId),
  });
}
